import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

const createCompany = (apiToken, companyCode) => dispatch => {
  consolelog('[API CALL] createCompany()');
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_CREATE_COMPANY;
  const { cancelToken, cancelTokenKey } = createCancelToken('createCompany');
  const params = {
    cancelToken,
    companyCode,
  };
  return axios
    .post(url, params)
    .then(res => {
      delCancelToken(cancelTokenKey);
      const type = res.data.result
        ? actionTypes.SUCCESS_API_CREATE_COMPANY
        : actionTypes.ERROR_API_CREATE_COMPANY;
      dispatch({ type, payload: res.data });
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
    });
};

export default createCompany;
